import { environment } from 'src/environments/environment';

export const MARKET_LIST = 'https://api.coingecko.com/api/v3/coins/markets';
export const MARKET_DETAIL = 'https://api.coingecko.com/api/v3/coins/{0}'
export const EXCHANGE_LIST = 'https://api.coingecko.com/api/v3/exchanges';
export const MARKET_CHART = 'https://api.coingecko.com/api/v3/coins/{0}/market_chart';
export const MARKET_TICKERS = 'https://api.coingecko.com/api/v3/coins/{0}/tickers';
export const MARKET_CATEGORIES = 'https://api.coingecko.com/api/v3/coins/categories/list';
export const EXCHANGE_RATES = 'https://api.coingecko.com/api/v3/exchange_rates';
export const TRENDING = 'https://api.coingecko.com/api/v3/search/trending';

// Source unique de vérité : DEV_BASE_URL et BASE_URL dérivent de environment.apiBaseUrl
// (build androidlocal → http://10.0.2.2:5026/api/, dev navigateur → http://localhost:5026/api/,
// prod → l'API prod). Avant, DEV_BASE_URL était figé sur localhost:5026 : IrisAppService (donc
// agent-rental.service, etc.) tapait toujours localhost, injoignable depuis l'émulateur Android.
export const DEV_BASE_URL  = environment.apiBaseUrl;
export const PROD_BASE_URL = 'https://iris-app-api.cryptoenafrique.com/api/';
export const BASE_URL      = environment.apiBaseUrl;

export const PROD_API = 'https://api.coingecko.com/api/v3/search/trending';

//News
export const NEWS_LIST = 'https://min-api.cryptocompare.com/data/v2/news/';